/*
 * @providesModule SMSCodeInputStyle
 */

import {StyleSheet} from 'react-native';
import SkillzStyle from 'SkillzStyle';

export const createStyles = (isDarkTheme: boolean) => {
  const {viewSecondaryColor, playButtonGradient} = SkillzStyle.getOverriddenFallbackTheme();
  return StyleSheet.create({
    otpSelected: {
      borderColor: playButtonGradient[0],
      borderWidth: 2,
    },
    otpInput: {
      ...SkillzStyle.fullStyles.textColorPrimary,
      fontSize: 20,
      fontFamily: 'OpenSans-Bold',
      textAlign: 'center',
      textAlignVertical: 'center',
    },
    otpContainerWithBorder: {
      borderColor: 'transparent',
      backgroundColor: isDarkTheme ? 'rgba(0, 0, 0, 0.25)' : viewSecondaryColor?.backgroundColor,
      opacity: 0.86,
      borderWidth: 1,
      borderRadius: 12,
      width: 56,
      height: 56,
      flex: 1,
      justifyContent: 'center',
      marginHorizontal: 2,
    },
  });
};
